import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSession, getCurrentAccount, getSavedPersonInfo } from "../../reducers/selectors";
import { getAccountAnswers } from "../../services/api/person";

import style from "./AccountProfileTest.scss";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";

export const AccountProfileTest = () => {
  const currentAccount = useSelector(getCurrentAccount);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const profileRiskString = {
    Conservative: "Conservador",
    Moderate: "Moderado",
    Aggressive: "Agresivo",
  };

  useEffect(() => {
    if (currentAccount.AccountNumber) {
      setLoading(() => true);
      getAccountAnswers({ accountNumber: currentAccount.AccountNumber })
        .then(({ response }) => {
          setQuestions(response.questions);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoading(() => false);
        });
    }
  }, [currentAccount]);

  if (!currentAccount) return <CircularProgress />;

  return (
    <Fragment>
      <div className={style.container}>
        <p className={style.title}>Perfil inversor de la cuenta</p>
        <div className={style.welcomeContainer}>
          <div className={style.answerTitle}>El perfil inversionista de su cuenta es</div>

          <div className={style.investorType}>{profileRiskString[currentAccount.accountProfileRisk]}</div>

          {questions.map((question, index) => {
            return <Question key={index} question={question} />;
          })}
        </div>
      </div>
    </Fragment>
  );
};

const Question = ({ question }) => {
  const [active, setActive] = useState("");

  return (
    <form className={style.questionContainer}>
      <p className={style.questionTitle}>{question.QuestionDescription}</p>
      {question.Answer.map((answer, index) => {
        const key = `${question.QuestionId}-${index}`;

        return (
          <div key={key} className={style.answerRow}>
            <span className={style.answerText}>{answer.AnswerDescription}</span>
          </div>
        );
      })}
    </form>
  );
};
